import React from "react";
import { getSmoothStepPath ,EdgeProps } from "reactflow";



/* ----------------------------------
   Component
---------------------------------- */

const NextEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}) => {
  const [path, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      {/* ---------- NEXT ARROW MARKER ---------- */}
      <defs>
        <marker
          id={`next-arrow-${id}`}
          markerWidth="6"
          markerHeight="6"
          viewBox="0 0 8 8"
          refX="7"
          refY="4"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M 0 0 L 8 4 L 0 8 z" fill="#198754" />
        </marker>
      </defs>

      {/* ---------- NEXT PATH ---------- */}
      <path
        d={path}
        fill="none"
        stroke="#198754"
        strokeWidth={2}
        markerEnd={`url(#next-arrow-${id})`}
      />

      {/* ---------- NEXT LABEL ---------- */}
      <foreignObject
        x={labelX - 50}
        y={labelY - 14}
        width={100}
        height={28}
        style={{ pointerEvents: "none" }}
      >
        <div
          style={{
            pointerEvents: "all",
            background: "#198754",
            color: "#fff",
            fontSize: 11,
            borderRadius: 4,
            padding: "2px 8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6,
            boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
          }}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            e.stopPropagation();
            e.preventDefault();

            data.onEdit(data.edgeId, {
              id: data.id,
              type: data.type,
              fromStageId: data.fromStageId,
              toStageId: data.toStageId,
              actionLabel: data.actionLabel,
              status: data.status,
              x: e.clientX,
              y: e.clientY,
            });
          }}
        >
          <span>NEXT</span>
          <i className="ri-edit-2-line" />
        </div>
      </foreignObject>
    </>
  );
};

export default NextEdge;
